import { api } from "@/lib/api";

// base64url -> Uint8Array for VAPID application server key
function urlBase64ToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function getPushSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return null;
  return await reg.pushManager.getSubscription();
}

export async function enablePushNotifications() {
  if (!pushSupported()) throw new Error("Notifications aren't supported on this browser");
  if (Notification.permission === "denied") {
    throw new Error("Notifications are blocked — enable them in your browser settings");
  }
  if (Notification.permission !== "granted") {
    const p = await Notification.requestPermission();
    if (p !== "granted") throw new Error("Permission denied");
  }
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.key) throw new Error("Server not configured for push");
  const existing = await reg.pushManager.getSubscription();
  if (existing) {
    // re-register with backend in case sub was lost server-side
    await api.post("/push/subscribe", existing.toJSON());
    return existing;
  }
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.key),
  });
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
}

export async function disablePushNotifications() {
  const sub = await getPushSubscription();
  if (!sub) return;
  try { await api.post("/push/unsubscribe", sub.toJSON()); } catch {}
  try { await sub.unsubscribe(); } catch {}
}
